export default __webpack_public_path__ + "static/media/multiDatasetChild.59038481.svg";